import Vue from 'vue'
import 'babel-polyfill';
import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n

import '@/styles/index.scss' // global css
import '@/styles/element-common.css' // element css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control
import VueAMap from 'vue-amap';

VueAMap.initAMapApiLoader({
  key: 'fa3d2d455fc1e1cba62a36ed305627c3',
  plugin: ['AMap.Geocoder',"AMap.PlaceSearch"],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.5'
});

Vue.use(ElementUI, { locale })
Vue.use(VueAMap)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js